import { Box, Button, Switch, useMediaQuery, Typography } from "@mui/material";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import icon from "../../assets/icons/ProjectIcon.png";
import { jwtDecode } from "jwt-decode";
import { useOrganization } from "../../utils/OrganizationContext";

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const MUTED = "#66748A";
const LINE = "#E4E9EF";
const PRIMARY = "#0B5C8A";

const primaryBtnSx = {
  height: 36,
  px: 2,
  gap: 1,
  borderRadius: "9px !important",
  background: `${PRIMARY} !important`,
  color: "#FFFFFF !important",
  border: "0 !important",
  fontFamily: FONT,
  fontSize: 13.5,
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "none",
  whiteSpace: "nowrap",
  "&:hover": { background: "#084767 !important" },
};
const secondaryBtnSx = {
  ...primaryBtnSx,
  background: "#FFFFFF !important",
  color: `${INK} !important`,
  border: "1px solid #D5DEE7 !important",
  "&:hover": { background: "#F4F7FA !important" },
};
const goToBtnSx = {
  minWidth: 0,
  height: 28,
  px: 1.25,
  borderRadius: "8px",
  border: "1px solid #D5DEE7",
  background: "#FFFFFF",
  color: INK,
  fontFamily: FONT,
  fontSize: 12.5,
  fontWeight: 600,
  textTransform: "none",
  "&:hover": { background: "#EAF2FB", borderColor: "#8FC3E6", color: "#1B4F82" },
};

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const orgId = JSON.parse(localStorage.getItem("org"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 750px)");
  // const [role, setRole] = useState();
  const { role } = useOrganization();

  // useEffect(() => {
  //   const getOrg = async () => {
  //     const res = await axios.get(
  //       `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${storedUser.username}`,
  //       { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
  //     );
  //     if (
  //       !res.data.orgLogo &&
  //       !res.data.orgUsername &&
  //       !res.data.orgShortform
  //     ) {
  //       navigate(`/dashboard/org-details`);
  //     }
  //   };
  //   getOrg();
  // }, []);

  useEffect(() => {
    const getProjects = async () => {
      if (!storedUser?.accessToken) return;

      // const decoded = jwtDecode(storedUser.accessToken);
      // const role = decoded.userRole?.[0];
      // setRole(role);
      try {
        const url =
          role === "ADMIN"
            ? `${process.env.REACT_APP_BACKEND_URL}/project/all?orgId=${orgId}`
            : `${process.env.REACT_APP_BACKEND_URL}/project/team/all?orgId=${orgId}`;

        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${storedUser.accessToken}` },
        });
        setProjects(res.data || []);
      } catch (error) {
        console.log(error.response.data.Exception || "Access denied");
      }
    };
    getProjects();
  }, [orgId]);

  const columns = [
    // {
    //   field: "projectId",
    //   headerName: "Project ID",
    //   width: 100,
    // },
    {
      field: "projectName",
      headerName: "Project Name",
      width: 250,
      renderCell: (params) => (
        <>
            <Box
              sx={{
                cursor: "pointer",
                fontWeight: 700,
                color: INK,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                "&:hover": { color: PRIMARY, textDecoration: "underline", textUnderlineOffset: "3px" },
              }}
              onClick={() => {
                const url =
                  role === "ADMIN" ? `/dashboard/projects/${params.row.projectId}` : `/dashboard/projects/${params.row.projectId}`;
                window.open(url, "_blank");
              }}
            >
              {params.row.projectName}
            </Box>
          {/* {role === "ADMIN" ? (
          ) : (
            <Box>{params.row.projectName}</Box>
          )} */}
        </>
      ),
    },
    {
      field: "builder",
      headerName: "Builder Name",
      width: 250,
    },
    {
      field: "location",
      headerName: "Location",
      width: 250,
    },
    {
      field: "goTo",
      headerName: "Go To",
      width: 250,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, height: "100%" }}>
          <Button
            variant="outlined"
            sx={{ ...goToBtnSx, mr: 0 }}
            onClick={() => handleGoTo("/dashboard/leads", params.row.projectId)}
          >
            Leads
          </Button>
          <Button
            variant="outlined"
            sx={goToBtnSx}
            onClick={() => handleGoTo("/dashboard/inventory", params.row.projectId)}
          >
            Inventory
          </Button>
        </Box>
      ),
    },
    // {
    //   field: "isTelegramAllowed",
    //   headerName: "Telegram Allowed",
    //   width: 180,
    //   renderCell: (params) => {
    //     const hasTelegramConfig =
    //       params.row.telegramBotId && params.row.telegramChatId;

    //     if (!hasTelegramConfig) {
    //       return (
    //         <Typography fontSize={12} color="error">
    //           Add Bot ID & Chat ID first
    //         </Typography>
    //       );
    //     }

    //     return (
    //       <Switch
    //         checked={Boolean(params.row.isTelegramAllowed)}
    //         onChange={async (e) => {
    //           const checked = e.target.checked;
    //           try {
    //             setProjects((prev) =>
    //               [...prev].map((p) =>
    //                 p.projectId === params.row.projectId
    //                   ? {
    //                       ...p,
    //                       isTelegramAllowed: checked,
    //                     }
    //                   : p,
    //               ),
    //             );
    //             await axios.put(
    //               `${process.env.REACT_APP_BACKEND_URL}/project/update-telegram?projectId=${params.row.projectId}`,
    //               {
    //                 isTelegramAllowed: e.target.checked,
    //               },
    //               {
    //                 headers: {
    //                   Authorization: `Bearer ${storedUser.accessToken}`,
    //                 },
    //               },
    //             );
    //           } catch (error) {
    //             console.log(error);
    //             setProjects((prev) =>
    //               [...prev].map((p) =>
    //                 p.projectId === params.row.projectId
    //                   ? {
    //                       ...p,
    //                       isTelegramAllowed: !checked,
    //                     }
    //                   : p,
    //               ),
    //             );

    //             alert(
    //               error?.response?.data?.Exception ||
    //                 "Failed to update telegram status",
    //             );
    //           }
    //         }}
    //       />
    //     );
    //   },
    // },
    // role === "ADMIN" && {
    //   field: "action",
    //   headerName: "Action",
    //   width: 150,
    //   renderCell: (params) => (
    //     <>
    //       <Link to={`/dashboard/projects/${params.row.projectId}`}>
    //         <Button>View</Button>
    //       </Link>
    //     </>
    //   ),
    // },
  ];

  const handleGoTo = (path, id) => {
    localStorage.setItem("projectId", JSON.stringify(id));
    navigate(
      path === "/dashboard/leads"
        ? role === "ADMIN"
          ? path
          : "/dashboard/project-dashboard"
        : path,
    );
  };

  const rows = projects ? projects : "";

  const handleEnableDisable = async (orgUserId, isEnable) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/org-user?orgUserId=${orgUserId}`,
        {
          isEnable: !isEnable,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div style={{ fontFamily: FONT, color: INK }}>
      <Box
        sx={{
          display: { xs: "block", sm: "flex" },
          justifyContent: "space-between",
          alignItems: "flex-end",
          gap: 2,
          mb: 2,
        }}
      >
        <Typography
          variant="h4"
          my={1}
          fontWeight={700}
          sx={{ fontFamily: FONT, fontSize: { xs: 24, sm: 27 }, fontWeight: 800, letterSpacing: "-0.028em", color: INK, mb: { xs: 1.5, sm: 0 } }}
        >
          List of Projects
        </Typography>
        {role === "ADMIN" && (
          <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1 }}>
            <Link to={`/dashboard/create-structure`} style={{ textDecoration: "none" }}>
              <Button
                className="btn-contained"
                sx={{ ...secondaryBtnSx, width: { xs: "100%", sm: "auto" }, height: { xs: 44, sm: 36 }, mb: 0 }}
              >
                <img src={icon} alt="Icon" width={18} style={{ opacity: 0.8 }} /> + Structure
              </Button>
            </Link>
            <Link to={`/dashboard/create-project`} style={{ textDecoration: "none" }}>
              <Button
                className="btn-contained"
                sx={{ ...primaryBtnSx, width: { xs: "100%", sm: "auto" }, height: { xs: 44, sm: 36 }, mb: 0 }}
              >
                <PersonAddAltRoundedIcon sx={{ fontSize: 18 }} /> Create New Project
              </Button>
            </Link>
          </Box>
        )}
      </Box>
      <div>
        {isMobile ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
            {projects?.map((p) => (
              <div
                key={p.projectId}
                className="card"
                style={{
                  background: "#FFFFFF",
                  border: `1px solid ${LINE}`,
                  borderRadius: 14,
                  padding: "14px 14px 12px",
                  boxShadow: "none",
                  margin: 0,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ minWidth: 0 }}>
                    <Typography
                      fontSize={"16px"}
                      color={INK}
                      fontWeight={"800"}
                      sx={{
                        fontFamily: FONT,
                        letterSpacing: "-0.015em",
                        cursor: "pointer",
                        "&:active": {
                          color: PRIMARY,
                        },
                      }}
                      onClick={() => {
                        const url =
                          role === "ADMIN" && `/dashboard/projects/${p.projectId}`;
                        window.open(url, "_blank");
                      }}
                    >
                      {p.projectName}
                    </Typography>
                    <Typography
                      fontSize={"12px"}
                      color={MUTED}
                      fontWeight={"500"}
                      sx={{ fontFamily: MONO, mt: 0.25 }}
                    >
                      ID: {p.projectId}
                    </Typography>
                  </div>
                </div>
                <Typography
                  color={INK_2}
                  fontSize={"13px"}
                  fontWeight={500}
                  mt={1.5}
                  sx={{ display: "flex", alignItems: "center", gap: 1, fontFamily: FONT }}
                >
                  <MeetingRoomOutlinedIcon sx={{ fontSize: 16, color: MUTED }} /> {p.builder}
                </Typography>
                <Typography
                  color={INK_2}
                  fontSize={"13px"}
                  fontWeight={500}
                  mt={0.75}
                  mb={1.25}
                  sx={{ display: "flex", alignItems: "center", gap: 1, fontFamily: FONT }}
                >
                  <LocationOnOutlinedIcon sx={{ fontSize: 16, color: MUTED }} /> {p.location}
                </Typography>
                <hr style={{ border: 0, borderTop: "1px solid #F1F4F8", margin: "0 -14px 10px" }} />
                {/* <div style={{ display: "flex", justifyContent: "end" }}>
                  <Button
                    onClick={() => navigate(`/dashboard/projects/${p.projectId}`)}
                    sx={{ color: "#059669 !important" }}
                  >
                    View
                  </Button>
                </div> */}
                <div style={{ display: "flex", justifyContent: "end", gap: 8 }}>
                  <Button
                    variant="outlined"
                    sx={{ ...goToBtnSx, height: 44, flex: 1, fontSize: 13.5, mr: 0 }}
                    onClick={() => handleGoTo("/dashboard/leads", p.projectId)}
                  >
                    Leads
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{ ...goToBtnSx, height: 44, flex: 1, fontSize: 13.5 }}
                    onClick={() => handleGoTo("/dashboard/inventory", p.projectId)}
                  >
                    Inventory
                  </Button>
                </div>
              </div>
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              background: "#fff",
              border: `1px solid ${LINE}`,
              borderRadius: "14px",
              overflow: "hidden",
            }}
          >
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 20,
                  },
                },
              }}
              pageSizeOptions={[20]}
              disableRowSelectionOnClick
              disableColumnSelector
              disableDensitySelector
              slots={{ toolbar: CustomToolbar }}
              getRowId={(row) => row.projectId}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
              }
              rowHeight={50}
              columnHeaderHeight={40}
              sx={{
                position: "relative",
                border: "none",
                fontFamily: `${FONT} !important`,
                color: INK,

                "& .MuiDataGrid-columnHeaderTitle": {
                  fontFamily: FONT,
                  fontWeight: "700 !important",
                  fontSize: 10.5,
                  letterSpacing: "0.09em",
                  textTransform: "uppercase",
                  color: MUTED,
                },
                "& .MuiDataGrid-columnHeaders": {
                  background: "#F7F9FC !important",
                  color: MUTED,
                  fontSize: "14px",
                  borderRadius: 0,
                  borderTop: `1px solid ${LINE}`,
                  borderBottom: `1px solid ${LINE}`,
                },
                "& .MuiDataGrid-columnHeader, & .MuiDataGrid-filler": {
                  background: "#F7F9FC !important",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#F4F7FA",
                },
                "& .MuiDataGrid-cell": {
                  fontSize: "13.5px",
                  color: INK_2,
                  border: "none",
                  borderBottom: "1px solid #F1F4F8",
                  display: "flex",
                  alignItems: "center",
                },
                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: `1px solid ${LINE}`,
                },
                "& .MuiTablePagination-root, & .MuiTablePagination-displayedRows": {
                  fontFamily: MONO,
                  fontSize: 12,
                  color: MUTED,
                },
                "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                  color: "#000 !important",
                  border: "1px solid #B0B0B0",
                  borderRadius: "12px",
                  padding: 1,
                },
                "& .MuiInputBase-root-MuiInput-root::after": {
                  borderBottom: "none !important",
                },
                "& .MuiInputBase-root-MuiInput-root": {
                  borderBottom: "none !important",
                },
                [`& .${gridClasses.row}.even`]: {
                  backgroundColor: "#FFFFFF",
                  // '&:hover': {
                  //   backgroundColor: "#f6f6f6",
                  // },
                },
                [`& .${gridClasses.row}.odd`]: {
                  backgroundColor: "#FCFDFE",
                },
                [`& .${gridClasses.row}.even:hover, & .${gridClasses.row}.odd:hover`]: {
                  backgroundColor: "#F4F7FA",
                },
                "& .MuiInput-underline:before": {
                  borderBottom: "none !important",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "none !important",
                },
                "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                  borderBottom: "none !important",
                },
              }}
            />
          </Box>
        )}
      </div>
    </div>
  );
};

export default Projects;

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{ display: "flex", justifyContent: "end", px: 1.75, py: 1.25, gap: 1 }}
    >
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #D5DEE7",
          borderRadius: "9px",
          padding: "3px 10px",
          background: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#F4F7FA",
          },
          "&:focus-within": {
            borderColor: PRIMARY,
          },
          "& .MuiInputBase-root": {
            borderRadius: "9px",
            fontFamily: FONT,
            fontSize: 13.5,
          },
          "& .MuiInputBase-root::before, & .MuiInputBase-root::after": {
            display: "none",
          },
          "& .MuiSvgIcon-root": { color: MUTED, fontSize: 18 },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
